import React, {Component} from "react";
import PropTypes from "prop-types";
import ReactDataGrid from "react-data-grid";
import { Toolbar, Data } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, Button, ButtonToolbar, Breadcrumb } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import Spinner from '../../components/Widgets/spinner';
import checkPermission from '../Common/permissions';
import genericRadioFilter from '../Common/genericRadioFilter';
import dateFilterRadios from '../Common/dateFilterRadios';
import ContentWrapper from "../Layout/ContentWrapper";
import StringFormatter from "./booleanFormatter";
import GenericProductSuggest from "../../containers/Common/GenericProductSuggest";
import {BD_RMA_URL} from "../../actions/url";
import {toFromDates} from "../Common/cleanDates";
import { RMADateFormatter } from './rmaDateFormatter';

class Rma extends Component {
  static contextTypes = {
    router: React.PropTypes.object
};
    constructor() {
        super();
        this.state = {
            status: 'all', 
            FromDate: undefined,
            ToDate: undefined,
            days: '7',
            search: '',
            productSearchType: 'ProductNum',
            rows: [],
            selectedRows: null,
            filters: {},
            sortColumn: null,
            sortDirection: null,
            path: null,
            filteredByItem: false,
        }
    }

    componentDidMount() {
      const fromDate = '1900-01-01';
      const toDate = '3000-01-01';
      const days = 7;
      const status = 'all';
      this.props.setDefaultDays('rma');
      this.props.setDefaultOfForm('status', 'all', 'rma');
      if (this.props.location.pathname === '/dispatchRMA') {
        this.props.fetchDispatchReturns(fromDate, toDate, days, status);
        this.setState({path: 'dispatchRMA'})
      } else if (this.props.location.pathname === '/customerRMA') {
        this.props.fetchCustomerReturnsByFilter(fromDate, toDate, days, status);
        this.setState({path: 'customerRMA'})
      }
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.customerReturns.bd_rmas && this.props.customerReturns.bd_rmas !== nextProps.customerReturns.bd_rmas) {
        let rows = nextProps.customerReturns.bd_rmas;
        rows = rows.filter(r => r !== null);
        this.setState({rows: rows})
      }

      if (nextProps.dispatchReturns.bd_rmas && this.props.dispatchReturns.bd_rmas !== nextProps.dispatchReturns.bd_rmas) {
        let rows = nextProps.dispatchReturns.bd_rmas;
        rows = rows.filter(r => r !== null);
        this.setState({rows: rows})
      }

      if (nextProps.Days && nextProps.Days !== this.props.Days) {
        if (nextProps.Days !== -1) {
          this.props.setDefaultOfForm('FromDate', null, 'rma');
          this.props.setDefaultOfForm('ToDate', null, 'rma');
        }
        this.setState({ days: nextProps.Days });
      }

      if (nextProps.Status && nextProps.Status !== this.props.Status) {
        const {path} = this.state;
          const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
          const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
          let { days } = this.state;
          if (days == null) {
            days = 7;
          }
          if (path === 'customerRMA') {
            this.props.fetchCustomerReturnsByFilter(fromDate, toDate, days, nextProps.Status, this.state.search)
          } else if (path === 'dispatchRMA') {
              this.props.fetchDispatchReturns(fromDate, toDate, days, nextProps.status, this.state.search);
          }
        }
      }

    redirect = e => {
      e.preventDefault();
      let customer_id
      if (this.state.selectedRows) {
        customer_id = this.state.selectedRows[0].RMA_ID;
      }
      customer_id = customer_id || '';
      this.context.router.push(`/${this.state.path}/${customer_id}`);
    }

    createNew = e => {
      e.preventDefault();
      this.props.resetCurrentForm();
      this.context.router.push(`/${this.state.path}/new`);
    }

    setToDate = (e) => {
      if (e < this.state.FromDate) {
        return;
      }
      this.setState({ToDate: e})
    }

    setFromDate = (e) => {
      if (e > this.state.ToDate) {
        return;
      }
      this.setState({FromDate: e})
    }

    setToRangeSearch = () => {
      this.setState({days: '-1'})
    }

    handleStatusFilterChange = (status) => {
      const {returnsFilter} = this.props;
      const {path} = this.state;
      if (!returnsFilter) {
      const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
      const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
      let {days } = this.state;
      if (!this.state.days) {
        days = 7;
      }
      this.setState({status: status}, () => {
        if (path === 'customerRMA') {
          this.props.fetchCustomerReturnsByFilter(fromDate, toDate, days, status, this.state.search)
        } else if (path === 'dispatchRMA') {
          this.props.fetchDispatchReturns(fromDate, toDate, days, status, this.state.search);
        }
      })
    } else {
      this.setState({status: status}, () => {});
      }
    }

    exportData = () => {
      const {path, search, status} = this.state;
      let rmaURL;
      const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
      const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
      let {days } = this.state;
      if (!this.state.days) {
        days = 7;
      }
      const dates = toFromDates(days, fromDate, toDate);
      if (path === "dispatchRMA") {
        rmaURL = `${BD_RMA_URL}fix/search/export/?Bearer=${localStorage.getItem('token')}`;
      } else if (path === "customerRMA") {
        rmaURL = `${BD_RMA_URL}/search/export/?Bearer=${localStorage.getItem('token')}`;
      }
      return (
        <div>
        <Button
          style={{marginLeft: 15}}
          bsStyle="success"
          disabled={!this.state.rows}
          href={rmaURL}>
          <em className="fa fa-arrow-circle-o-down" />
          <Translate value="excel" />
        </Button>
        </div>
      )
    }

    fetchReturnsByDetails = (days) => {
      const {path} = this.state;
      let FromDate = '1900-01-01';
      let ToDate = '3000-01-01';
      if (this.state.FromDate != null) {
        FromDate = this.formatDate(this.state.FromDate);
      }
      if (this.state.ToDate != null) {
        ToDate = this.formatDate(this.state.ToDate);
      }
      if (days === '-1' || days === -1) {
        this.setState({days}, () => {
          if (path === 'customerRMA') {
            this.props.fetchCustomerReturnsByFilter(FromDate, ToDate, days, this.state.status, this.state.search)
          } else if (path === 'dispatchRMA') {
            this.props.fetchDispatchReturns(FromDate, ToDate, days, this.state.status, this.state.search)
          }
        })
      } else {
        this.setState({days: days, FromDate: null, ToDate: null}, () => {
          if (path === 'customerRMA') {
            this.props.fetchCustomerReturnsByFilter(FromDate, ToDate, days, this.state.status, this.state.search)
          } else if (path === 'dispatchRMA') {
            this.props.fetchDispatchReturns(FromDate, ToDate, days,status, this.state.search)
          }
        })
      }
      this.setState({selectedRows: [{}], days: days});
    }

    onEnter = (e) => {
      if (e.charCode === 13) {
       this.fetchSearchReturns()
      } else {
        return false
      }
    }

    fetchSearchReturns = () => {
      const {path, status, days} = this.state;
      let FromDate = '1900-01-01';
      let ToDate = '3000-01-01';
      if (this.state.FromDate != null) {
        FromDate = this.formatDate(this.state.FromDate);
      }
      if (this.state.ToDate != null) {
        ToDate = this.formatDate(this.state.ToDate);
      }
      if (path === 'customerRMA') {
        this.props.fetchCustomerReturnsByFilter(FromDate, ToDate, days, status, this.state.search)
      } else if (path === 'dispatchRMA') {
        this.props.fetchDispatchReturns(FromDate, ToDate, days,status, this.state.search)
      }
    }

    renderSearch = (e) => {
      let {days } = this.state;
      if (!this.state.days) {
        days = 7;
      }
      let{status} = this.state;
      const {path} = this.state;
      const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
      const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
      if (!this.state.filteredByItem) {
      return (
        <div className="control-dropdown-rma">
          <GenericProductSuggest
            value={this.state.search}
            onChange={(e, { newValue }) => {
              this.setState({ search: newValue });
            }}
            onKeyPress={(e) => this.onEnter(e)}
          />
        </div>
      )
          }
          return (
            <div className="control-dropdown-rma" id="suggestion-box">
            {this.state.search}
            <em
              className="fa fa-times pull-right"
              onClick={() => {
                this.setState({ filteredByItem: false, search: ''}, () => {
                  this.props.fetchCustomerReturnsByFilter(fromDate, toDate, days, status, this.state.search);
                });
              }}
            />
          </div>
          )
    }

    formatDate(date) {
      let formattedDate = `${date.getFullYear()}-`;
      formattedDate += `${date.getMonth() + 1}-`;
      if (date.getDate() < 10) {
        formattedDate += `0${date.getDate()}`;
      } else {
        formattedDate += date.getDate();
      }
      return formattedDate;
    }

    renderTable() {
      if (this.props.isLoading && !this.props.error) return <Spinner />;
      else if (this.props.error) {
        return (
          <ContentWrapper>
            <div className="alert alert-danger">{JSON.stringify(this.props.error)}</div>
          </ContentWrapper>
        );
      }
  
      // Parameters of the react-data-grid
  
      const tableHeight = window.innerHeight < 930 ? 270 : 270;
  
      const getRows = () => Data.Selectors.getRows(this.state);
      const getSize = () => getRows().length;
  
      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return rows[rowIdx];
      };
  
      const onRowClick = (rowIdx, row) => {
        if (rowIdx !== -1) {
          const rows = getRows();
          rows.map((r) => {
            r.isSelected = false;
          });
          rows[rowIdx].isSelected = true;
          this.setState({ rows, selectedRows: [rows[rowIdx]] });
        }
      };
  
      const onCellSelected = (coordinates) => {
        const rows = getRows();
        rows.map((r) => {
          r.isSelected = false;
        });
        rows[coordinates.rowIdx].isSelected = true;
        this.setState({ rows, selectedRows: [rows[coordinates.rowIdx]] });
      };
  
      const onClearFilters = () => {
        this.setState({ filters: {} });
      };
  
      // Handle the sortable function
  
      const handleGridSort = (sortColumn, sortDirection) => {
        const state = Object.assign({}, this.state, { sortColumn, sortDirection });
        this.setState(state);
      };
  
      const handleFilterChange = (filter) => {
        const { rows } = this.state;
        if (rows && rows.length !== 0) {
          rows.map((row) => {
            row.Dropship = row.IsDropship ? 'yes' : 'no';
          });
        }
        this.setState({ rows });
        const newFilters = Object.assign({}, this.state.filters);
        if (filter.filterTerm) {
          newFilters[filter.column.key] = filter;
        } else {
          delete newFilters[filter.column.key];
        }
        this.setState({ filters: newFilters });
      };
  
      const onRowsSelected = (rows) => {
        const newRows = getRows();
        const selectedRows = [newRows[rows[0].rowIdx]];
        newRows.map((r) => {
          r.isSelected = false;
        });
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = true;
        });
        this.setState({ rows: newRows, selectedRows });
      };
      const onRowsDeselected = (rows) => {
        const newRows = [...this.state.rows];
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = false;
        });
        this.setState({ rows: newRows, selectedRows: [] });
      };
  
      const columns = [
        {
          key: 'RMA_ID',
          name: <Translate value="rma_id" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'RMA_Content',
          name: <Translate value="Product" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
        },
        {
          key: 'Is_Warranty',
          name: <Translate value="warranty" />,
          formatter: StringFormatter,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
        },
        {
          key: 'Product_SN',
          name: <Translate value="product_num" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'Product_Description',
          name: <Translate value="description" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 160,
        },
        {
          key: 'Fix_Status',
          name: <Translate value="Status" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 100,
        },
        {
          key: 'Customer_Name',
          name: <Translate value="customer_name" />,
          resizable: true,
          sortable: true,
          width: 140,
          filterable: true,
        },
        {
          key: 'Customer_Address',
          name: <Translate value="address" />,
          resizable: true,
          sortable: true,
          width: 150,
          filterable: true,
        },
        {
          key: 'Customer_Email',
          name: <Translate value="email" />,
          resizable: true,
          sortable: true,
          width: 150,
          filterable: true,
        },
        {
          key: 'Customer_Mobile',
          name: <Translate value="phone" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
        },
        {
          key: 'Date_Created',
          name: <Translate value="date_created" />,
          resizable: true,
          sortable: true,
          width: 130,
          filterable: true,
          formatter: RMADateFormatter
        },
        {
          key: 'Dispatch_Date',
          name: <Translate value="date_dispatched" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
          formatter: RMADateFormatter
        },
        {
          key: 'Date_Received_Freight',
          name: <Translate value="date_received" />,
          resizable: true,
          sortable: true,
          width: 120,
          filterable: true,
          formatter: RMADateFormatter
        },
      ];
  
      // React Table Purchase Order Full Table
      return (
        <Row>
          <Col xs={12}>
            <div id="PurchaseOrderList-dataGrid1">
              <ReactDataGrid
                rowKey="RMA_num"
                enableCellSelect
                onClearFilters={onClearFilters}
                onGridSort={handleGridSort}
                toolbar={<Toolbar enableFilter />}
                onAddFilter={handleFilterChange}
                columns={columns}
                rowHeight={25}
                headerRowHeight={45}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                minHeight={tableHeight}
                enableRowSelect="single"
                onRowUpdated={this.handleRowUpdated}
                rowSelection={{
                  showCheckbox: true,
                  onRowsSelected,
                  onRowsDeselected,
                  selectBy: {
                    isSelectedKey: 'isSelected',
                  },
                }}
                onRowClick={onRowClick}
                onCellSelected={onCellSelected}
              />
            </div>
          </Col>
        </Row>
      );
    }

    render() {
      let customer_id
      if (this.state.selectedRows) {
        customer_id = this.state.selectedRows[0].RMA_ID;
      }
      customer_id = customer_id || '';
        return (
            <ContentWrapper>
                <Breadcrumb>
                    <Breadcrumb.Item>
                      <Translate value="rma" />
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active="true">         
                        <Translate value={this.state.path === 'dispatchRMA' ? "dispatch_rma" : "customer_rma"} />
                    </Breadcrumb.Item>
                  </Breadcrumb> {/* End Navigation Trail */}
                  <Grid id="purchase-order-list">
                  <Row>
            <Col xs={12}>
              <Panel id="date-range-picker" className="form-horizontal">
                <Row>
                  <Col xs={2}>
                    <h3 className="filter-title">
                      <Translate value="order_status" />
                      <span className="colon">:</span>
                    </h3>
                  </Col>
                  <Col xs={10}>
                    <div id="statusFilterRadios" className="form-horizontal">
                      {genericRadioFilter({
                        content: [
                          {
                            option: 'all',
                            id: 'all-radio-filter',
                            name: 'statusFilterRadios',
                            labelName: 'all',
                          },
                          {
                            option: 'Unreceived',
                            id: 'unreceived-radio-filter',
                            name: 'statusFilterRadios',
                            labelName: 'unreceived',
                          },
                          {
                            option: 'Received',
                            id: 'received-radio-filter',
                            name: 'statusFilterRadios',
                            labelName: 'received',
                          },
                          {
                            option: 'Repairing',
                            id: 'repairing-radio-filter',
                            name: 'statusFilterRadios',
                            labelName: 'repairing',
                          },
                          {
                            option: 'Repaired',
                            id: 'repaired-radio-filter',
                            name: 'statusFilterRadios',
                            labelName: 'repaired',
                          },
                          {
                            option: 'Dispatched',
                            id: 'dispatched-radio-filter',
                            name: 'statusFilterRadios',
                            labelName: 'dispatched',
                          },
                        ],
                        value: this.state.status,
                        handleOnClick: this.handleStatusFilterChange,
                        type: 'buttons',
                      })}
                    </div>
                  </Col>
                  <Col xs={2}>
                    <h3 className="filter-title">
                      <Translate value="order_date" />
                      <span className="colon">:</span>
                    </h3>
                  </Col>
                  <Col xs={10}>
                    {dateFilterRadios({
                      handleOnClick: this.fetchReturnsByDetails,
                      setToRangeSearch: this.setToRangeSearch,
                      setFromDate: this.setFromDate,
                      setToDate: this.setToDate,
                      FromDate: this.state.FromDate,
                      ToDate: this.state.ToDate,
                      Days: this.state.days,
                    })}
                  </Col>
                </Row>
              </Panel>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <Panel className="position-relative table-collapse-fix">
                <div style={{ position: 'relative' }}>
                <ButtonToolbar className="table-buttons">
                <Button
                bsStyle="success"
                type="submit"
                onClick={(e) => this.createNew(e)}
                disabled={this.state.path === 'dispatchRMA'
                || !checkPermission('add_bd_rma_customer')}
                >
                  <em className="fa fa-plus" />
                  <Translate value="create" />
                </Button>
                <Button
                bsStyle="warning"
                type="button"
                onClick={ e => this.redirect(e)}
                disabled={ !customer_id || this.state.path === 'customerRMA' 
                    ? !checkPermission('change_bd_rma_customer') : !checkPermission('change_bd_rma')}
                >
                  <em className="fa fa-pencil" />
                  <Translate value="edit" />
                </Button>
                <Button
                  bsStyle="primary"
                  type="submit"
                  disabled={!this.state.search}
                  onClick={(e) => this.fetchSearchReturns(e)}>
                  <em className="fa fa-plus" />
                  <Translate value="search" />
                </Button>
                <Col xs={6}>
                  <Row>
                  <Col xs={12}>{this.renderSearch()}</Col>
                  </Row>
                </Col>
                {this.exportData()}
                </ButtonToolbar>
                </div>
                {this.renderTable()}              
              </Panel>
            </Col>
          </Row>
          </Grid>
            </ContentWrapper>
        )
    }
}

export default Rma;


// WEBPACK FOOTER //
// ./master/jsx/components/RMA/rma.jsx